import { Routes, Route } from 'react-router-dom';
import { Header, Footer, Modal, ScrollToTop } from './components';
import { Home, Dashboard, ErrorScreen, NewsPage, EventsPage, NewsItem, EventItem, SocialCounseling, InfoPage, AdminPanel } from './pages';
import { AuthProvider } from './provider/auth';
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: null
  });

  const openModal = (type) => {
    setModalState({
      isOpen: true,
      type
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: null
    });
  };

  return (
    <AuthProvider>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsItem />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventItem />} />
        <Route path="/social-counseling" element={<SocialCounseling />} />
        <Route path="/page/:pageId" element={<InfoPage />} />
        {/* <Route path="/admin/dashboard" element={<Dashboard />} /> */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/:tab" element={<AdminPanel />} />
        <Route path="/admin/:tab/new" element={<AdminPanel />} />
        <Route path="/admin/:tab/:id" element={<AdminPanel />} />
        <Route path="/admin/:tab/:id/edit" element={<AdminPanel />} />
        <Route path="*" element={<ErrorScreen error={404} />} />
      </Routes>
      <Footer onOpenModal={openModal} />
      <Modal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        type={modalState.type}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        icon={false}
      />
    </AuthProvider>
  );
}

export default App;